import React, {useEffect} from 'react'
import {useParams} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import Message from '../../components/Message'
import Loader from '../../components/Loader'
import {loadAnswer} from '../../actions/answerActions'
import AnswerResultDetails from '../../components/AnswerResultDetails.js'

const AdminResultsScreen = ({history}) => {
    const dispatch = useDispatch()
    const params = useParams()
    const id = params.id
    const {loading, error, answer} = useSelector(
        (state) => state.userAdminLoadAnswer
    )

    useEffect(() => {
        if (!loading) {
            if (!answer || !answer.completed) {
                dispatch(loadAnswer(id))
            }
        }
    }, [loading, answer, dispatch, id])

    return (
        <>
            {error && <Message variant="danger">{error}</Message>}
            {loading && !error && <Loader/>}
            {!loading && !error && (
                <AnswerResultDetails answer={answer}/>
            )}
        </>
    )
}

export default AdminResultsScreen
